// extracted by mini-css-extract-plugin
export default {"header3":"Header3_header3__he++I"};